import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {

  IsFromInvoice: boolean = false;
  DialogForm: FormGroup;
  errorMsg: string;
  entityName: any;

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, private form: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
          this.entityName = data.entityName;
        }
    }

    ngOnInit() {
        this.DialogForm = this.form.group({
            Note: ['']
        })
    }

    //Call on click Yes
    OnYes() {
      this.dialogRef.close("Y");
    }

    //Call on click close icon
    Close() {
        this.dialogRef.close("N");
    }

    //Call on click No
    OnNo() {
        this.dialogRef.close("N");
    }

}
